
const SET_POST_DATA = "DATA/SET_POST_DATA";

export function setPostData(data) {
  return async (dispatch, getState) => {
    if (data.inquiry_json_data) {
      let parsed = await JSON.parse(data.inquiry_json_data); // this is an array for some reason
      let objectified = {};
      for (let i=0; i<parsed.length; i++) {
        let item = parsed[i];
        let itemKeys = Object.keys(item);
        if (itemKeys.length > 0) {
          for (let k=0; k<itemKeys.length; k++) {
            let key = itemKeys[k];
            objectified[key] = item[key];
          }
        }
      }
      dispatch({type: SET_POST_DATA, payload: objectified.vehicleData});
    }
  }
}

const defaultState = {
  postData: null
};

export function dataReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_POST_DATA:
    return Object.assign({}, state, {
      postData: action.payload
    });
    default:
    return state;
  }
}
